import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-site-page',
  templateUrl: './no-site-page.component.html',
  styleUrls: ['./no-site-page.component.css']
})
export class NoSitePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
